// extracted by mini-css-extract-plugin
export var description = "_redotech-redo-web-src-theme-description";